module.exports = __webpack_public_path__ + "img/arcane.1c01b18e.jpg";